import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  getNodeIcon,
  getNodeColor,
  getLabel,
  isNodeReady
} from '../../../api/Tasks/task-node-operations';

const TaskNode = ({ node }) => {
  return (
    <div className="d-flex align-items-center justify-content-center h-100 position-relative">
      <div className="fa-layers fa-5x">
        <FontAwesomeIcon icon={getNodeIcon(node)} color={getNodeColor(node)} />
        {isNodeReady(node) && (
          <FontAwesomeIcon
            icon="check-circle"
            color="var(--primary)"
            transform="shrink-11 right-6 up-6"
          />
        )}
      </div>
      <p
        className="text-wrap text-break position-absolute w-100 text-center mb-0"
        style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
      >
        <small className="font-weight-bold">{getLabel(node)}</small>
      </p>
    </div>
  );
};

TaskNode.propTypes = {
  node: PropTypes.object.isRequired
};

export default TaskNode;
